export default {
    props: {
        location: {
            name: String,
            required: true
        },
        location_set: {
            type: Object,
            required: true
        },
        board: {
            type: Object,
            required: true
        }
    }
    ,
    methods: {
        moveLocationItem(transferData) {
            this.moveItem(transferData)
        },

        moveItem({fromTaskIndex, location}) {
            let fromTasks = this.board[location].tasks;
            console.log(this.taskIndex);
            this.$store.commit('MOVE_TASK', {
                fromTasks,
                fromTaskIndex,
                toTasks: this.location_set.tasks,
                toTaskIndex: this.taskIndex
            })
        }
        ,
    }
}
